import { lazy, FC, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";
import { WithChildren } from "../../_metronic/helpers";
const SettingPage = lazy(() => import("../modules/menu_setting/SettingPage"));
const BranchPage = lazy(() => import("../modules/branch/BranchPage"));
const ProductPage = lazy(() => import("../modules/products/ProductPage"));
const EmployeePage = lazy(() => import("../modules/employee/EmployeePage"));
const InventoryPage = lazy(() => import("../modules/inventory/InventoryPage"));
const MemberPage = lazy(() => import("../modules/member_management/MemberManagementPage"))
const SalePage = lazy(() => import("../modules/sale/SalePage"))
const LogPage = lazy(() => import("../modules/log/LogPage"))
const HolidayPage = lazy(() => import("../modules/holiday/HolidayPage"))
const DashboardPage = lazy(() => import("../modules/dashboard/DashboardPage"))
const ReportPage = lazy(() => import("../modules/report/ReportPage"))
const WorkSchedulePage = lazy(() => import("../modules/work_schedule/WorkSchedulePage"))


const PrivateRoutes = () => {
	return (
		<Routes>
			<Route element={<MasterLayout />}>
				<Route
					path="main"
					element={
						<SuspensedView>
							<DashboardPage />
						</SuspensedView>
					}
				/>
				<Route
					path="products/*"
					element={
						<SuspensedView>
							<ProductPage />
						</SuspensedView>
					}
				/>
				<Route
					path="holiday/*"
					element={
						<SuspensedView>
							<HolidayPage />
						</SuspensedView>
					}
				/>
				<Route
					path="employee/*"
					element={
						<SuspensedView>
							<EmployeePage />
						</SuspensedView>
					}
				/>
				<Route
					path="work-schedule/*"
					element={
						<SuspensedView>
							<WorkSchedulePage />
						</SuspensedView>
					}
				/>
				<Route
					path="inventory/*"
					element={
						<SuspensedView>
							<InventoryPage />
						</SuspensedView>
					}
				/>
				<Route
					path="setting/*"
					element={
						<SuspensedView>
							<SettingPage />
						</SuspensedView>
					}
				/>
				<Route
					path="member/*"
					element={
						<SuspensedView>
							<MemberPage />
						</SuspensedView>
					}
				/>
				<Route
					path="sale/*"
					element={
						<SuspensedView>
							<SalePage />
						</SuspensedView>
					}
				/>
				<Route
					path="branch/*"
					element={
						<SuspensedView>
							<BranchPage />
						</SuspensedView>
					}
				/>
				<Route
					path="log/*"
					element={
						<SuspensedView>
							<LogPage />
						</SuspensedView>
					}
				/>
				<Route
					path="report/*"
					element={
						<SuspensedView>
							<ReportPage />
						</SuspensedView>
					}
				/>
			</Route>
		</Routes>
	);
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
	const baseColor = getCSSVariableValue("--bs-primary");

	TopBarProgress.config({
		barColors: {
			"0": baseColor,
		},
		barThickness: 1,
		shadowBlur: 5,
	});

	return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
